export enum ChannelType {
  PhoneCall = "phone_call",
  Message = "message",
  Live = "live",
}
